import { Injectable } from '@angular/core';
import { ApiUrlHelper } from 'app/_service/api-url-helper';
import { HttpClientHelper } from 'app/_service/http-helper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TvLiveService {

  constructor(
    private _apiUrlHelper: ApiUrlHelper,
    private _httpClientHelper: HttpClientHelper
  ) { }

  getTvLiveList(params = {page: 1, size: 24}): Observable<any> {
    const apiURL = this._apiUrlHelper.urlBuilder('get-tv-live-list', {
        pageindex: params.page,
        pagesize: params.size,
    });
    return this._httpClientHelper.get(apiURL).pipe(map(l => {
        return l.map(item => {
            return item;
        });
    }));
}
}
